//jsxhook

import { Label2 } from "@sixty-six-north/ui-system"
import { ThemeUIStyleObject } from "@theme-ui/css"
import React from "react"
import { Box } from "theme-ui"

export enum SummationAlignment {
  left,
  right
}

const SummationItem: React.FC<{
  id?: string
  sx?: ThemeUIStyleObject
  heading: string
  value: string
  alignment?: SummationAlignment
}> = ({ id, sx, heading, value, alignment = SummationAlignment.right }) => {
  const leftMargin = alignment === SummationAlignment.left ? "none" : "auto"

  const rightMargin = alignment === SummationAlignment.right ? "none" : "auto"

  return (
    <React.Fragment>
      <Box sx={{ marginBottom: 0 }}>
        <Label2 sx={{ color: "grey.1" }}>{heading}</Label2>
      </Box>
      <Box
        sx={{
          marginLeft: leftMargin,
          marginRight: rightMargin
        }}
      >
        <Label2 sx={{ color: "grey.1" }} id={id}>
          {value}
        </Label2>
      </Box>
    </React.Fragment>
  )
}

export default SummationItem
